import { gql, useQuery } from "@apollo/client";
import { ODOO_COMPANY_IDS } from "AppSettings";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";

const FETCH_ODOO_STOCK_LOCATIONS = gql`
  query FETCH_ODOO_STOCK_LOCATIONS {
    odooStockLocations(isInternal: true)
  }
`;

const OdooLocationsMultipleSelector = ({ value, onSelect, company }) => {
  const { loading, error, data } = useQuery(FETCH_ODOO_STOCK_LOCATIONS);

  if (loading)
    return (
      <div className="relative">
        <InlineSpinner text={null} size={14} />
      </div>
    );
  if (error) return <Errors error={error} />;

  const companyId = ODOO_COMPANY_IDS[company];
  const options = JSON.parse(data.odooStockLocations).filter((i) => {
    if (companyId) return i.company_id[0] === companyId;
    return true;
  });

  return (
    <div className="flex flex-wrap">
      {options.map((option, index) => (
        <label
          key={index}
          className="flex items-center space-x-2 cursor-pointer mr-2 mb-2"
        >
          <input
            type="checkbox"
            checked={value.some((v) => v.id === option.id)}
            onChange={(e) => {
              if (e.target.checked) {
                onSelect([
                  ...value,
                  { companyId: option.company_id[0], id: option.id },
                ]);
              } else {
                onSelect(value.filter((v) => v.id !== option.id));
              }
            }}
          />
          <span>{option.display_name}</span>
        </label>
      ))}
    </div>
  );
};

export default OdooLocationsMultipleSelector;
